<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Intermediary Comm/Disc Factors</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <cal-picker :label="'Inter Comm/Disc Factors as at'" v-model="effDate" @input="fetchInterCommDiscFactors()"></cal-picker>
      </v-flex>
      <v-flex xs6></v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="product" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.productDesc }}</td>
        <td class="text-xs-left">{{ formatDateTime2(props.item.effDate) }}</td>
        <td class="text-xs-left">{{ formatDateTime2(props.item.endDate) }}</td>
        <td class="text-xs-left">{{ props.item.fact1 }}</td>
        <td class="text-xs-left">{{ props.item.fact2 }}</td>
        <td class="text-xs-left">{{ props.item.fact3 }}</td>
        <td class="text-xs-left">{{ props.item.fact4 }}</td>
        <td class="text-xs-left">{{ props.item.fact5 }}</td>
        <td class="text-xs-left">{{ props.item.fact6 }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" review remove @review="doReview(props.item)" @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Add Inter Comm/Disc Factor
        <v-icon right>mdi-table-row-plus-before</v-icon>
      </v-btn>
    </v-card-text>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Inter Comm/Disc Factor?
      <div class="title">{{deleteInterDiscCommFactProduct}}</div>
      <div class="title">{{deleteInterDiscCommFact}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { ADMININTERMEDIARY_INTERCOMMDISCFACT, ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU } from '@/store/types'
import { formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      headers: [
        { text: 'Product', align: 'left', value: 'product', sortable: false },
        { text: 'Effective Date', align: 'left', value: 'effDate', sortable: false },
        { text: 'End Date', align: 'left', value: 'endDate', sortable: false },
        { text: 'Factor 1', align: 'left', value: 'fact1', sortable: false },
        { text: 'Factor 2', align: 'left', value: 'fact2', sortable: false },
        { text: 'Factor 3', align: 'left', value: 'fact3', sortable: false },
        { text: 'Factor 4', align: 'left', value: 'fact4', sortable: false },
        { text: 'Factor 5', align: 'left', value: 'fact5', sortable: false },
        { text: 'Factor 6', align: 'left', value: 'fact6', sortable: false },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      loading: false,
      items: [],
      promptRemove: false,
      selectedInterDiscCommFact: undefined,
      deleteInterDiscCommFactProduct: '',
      deleteInterDiscCommFact: '',
      effDate: undefined
    }
  },
  computed: {
  },
  methods: {
    async doInit() {
      const commitData = {
        interCommDiscFactTab: 0,
        displayRateTab: false,
        product: undefined,
        effDate: undefined
      }
      this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
      await this.fetchInterCommDiscFactors()
    },
    doReview(data) {
      const interCommDiscFactors = {
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }
      const commitData = {
        interCommDiscFactTab: 1,
        displayFactReviewTab: true,
        product: data.product,
        effDate: data.effDate
      }
      this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT, interCommDiscFactors)
      this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
      this.$router.push({ name: 'interCommDiscFactorReview', params: { product: data.product, effectiveDate: data.effDate } })
    },
    doNew() {
      const commitData = {
        interCommDiscFactTab: 1,
        displayFactReviewTab: true
      }
      this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
      this.$router.push({ name: 'interCommDiscFactorReview', params: { product: 'New' } })
    },
    async fetchInterCommDiscFactors() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscFactors
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            inter: this.inter,
            effDate: formatDisplayDateTime2(this.effDate)
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((interCommDiscFactor) => {
                const convertInterCommDiscFactor = {
                  product: interCommDiscFactor.product,
                  productDesc: interCommDiscFactor.productDesc,
                  effDate: interCommDiscFactor.effDate,
                  endDate: interCommDiscFactor.endDate,
                  fact1: this.formatFact(interCommDiscFactor.fact1),
                  fact2: this.formatFact(interCommDiscFactor.fact2),
                  fact3: this.formatFact(interCommDiscFactor.fact3),
                  fact4: this.formatFact(interCommDiscFactor.fact4),
                  fact5: this.formatFact(interCommDiscFactor.fact5),
                  fact6: this.formatFact(interCommDiscFactor.fact6),
                  revision: interCommDiscFactor.revision
                }
                this.items.push(convertInterCommDiscFactor)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedInterDiscCommFact = data
        this.deleteInterDiscCommFactProduct = data.product + ' - ' + data.productDesc
        this.deleteInterDiscCommFact = data.fact1 + ' / ' + data.fact2 + ' / ' + data.fact3 + ' / ' + data.fact4 + ' / ' + data.fact5 + ' / ' + data.fact6
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.interCommDiscFactorDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          inter: this.inter,
          product: this.selectedInterDiscCommFact.product,
          effDate: this.selectedInterDiscCommFact.effDate
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.fetchInterCommDiscFactors()
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatFact(fact) {
      if (fact && fact !== null) {
        return fact
      } else {
        return '-'
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  props: {
    inter: {
      type: String,
      default: ''
    }
  },
  created() {
    this.effDate = new Date()
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
